import { FilterLiveForm } from "ra-core";
import type { ReactNode } from "react";
import { SearchInput } from "@/components/admin/search-input";

/**
 * Shared header of the list pages: the title on the left, the search field
 * growing in the middle and the action buttons on the right. Meant to be
 * passed as the `actions` prop of <List> (with `title={false}`), so it lives
 * inside the list context and the search writes the `q` filter.
 */
export const ListHeader = ({
  title,
  searchPlaceholder,
  children,
}: {
  title: string;
  searchPlaceholder?: string;
  children?: ReactNode;
}) => (
  <div className="flex w-full flex-col gap-3">
    <h1 className="text-2xl font-semibold tracking-tight text-brand-navy">
      {title}
    </h1>
    <div className="flex flex-wrap items-center gap-3">
      <div className="min-w-56 flex-1">
        <FilterLiveForm>
          <SearchInput source="q" placeholder={searchPlaceholder} />
        </FilterLiveForm>
      </div>
      <div className="ml-auto flex shrink-0 items-center gap-2">{children}</div>
    </div>
  </div>
);
